import type { GridRenderEditCellParams } from '@mui/x-data-grid-pro';
import { Input } from '@tempo-io/sui-input';
import { useTranslation } from 'react-i18next';
import { useDurationFieldInput } from '@/common/hooks/useDurationFieldInput';
import { useTableCellMutation } from '../hooks/useTableCellMutation';
import type { ItemsTableRow } from '../types';

export const TimeSpentEditCell = ({
  id,
  row,
  api,
  field,
}: GridRenderEditCellParams<ItemsTableRow>) => {
  const { t } = useTranslation();
  const itemId = Number(id);
  const { commit: commitRow } = useTableCellMutation();

  const stopEditing = (ignoreModifications = false) =>
    api.stopCellEditMode({ id, field, ignoreModifications });

  const { value, setValue, commit } = useDurationFieldInput({
    committedSeconds: row.timeSpentSeconds ?? null,
    onCommit: (timeSpentSeconds) => commitRow({ itemId, api, row, data: { timeSpentSeconds } }),
  });

  const handleCommit = () => {
    if (commit()) stopEditing();
  };

  return (
    <Input
      autoFocus
      value={value}
      onChange={(e) => setValue(e.target.value)}
      onBlur={handleCommit}
      onKeyDown={(e) => {
        if (e.key === 'Enter') {
          e.preventDefault();
          handleCommit();
        } else if (e.key === 'Escape') {
          stopEditing(true);
        }
      }}
      placeholder={t(($) => $.adaptivePlanner.itemPanel.textPlaceholders.timeSpent)}
    />
  );
};
